import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const AVAILABLE_LEVITATE_FIELDS_QUERY_KEY = 'integrations-available-levitate-fields';

export function useGetAvailableLevitateFieldsQuery({
	integrationProvider,
	impersonationContext,
	enabled = true,
}: {
	integrationProvider: Api.IntegrationProvider;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		// Set here rather than per caller: Field Mappings and Tags & Key Facts share this query's cache entry
		meta: {
			toastErrorMessage: 'Failed to load Levitate fields',
			errorLogging: { category: 'Integrations', action: 'LoadAvailableLevitateFields-Error' },
		},
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IImportFieldConfig[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/availableFields/levitate`,
				}),
				'GET'
			);
		},
		queryKey: [AVAILABLE_LEVITATE_FIELDS_QUERY_KEY, integrationProvider, impersonationContext],
	});
}

export const invalidateAvailableLevitateFieldsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [AVAILABLE_LEVITATE_FIELDS_QUERY_KEY, impersonationContext] });
